<template>
    <div>
        <modal 
        name="otpVerificationModal" 
        classes="v-modal-sec"
        :min-width="200"
        :min-height="200"
        :scrollable="true"
        :reset="true"
        width="500px"
        height="auto"> 
        <div class="v-modal verification_modal">
            <div class="popup-header">
                <h2 class="popup-title">Verification Complete</h2>
                <span @click="hideMe()">
                <em class="material-icons">close</em>
                </span>
            </div>
            
            <form @submit.prevent data-vv-scope="verificationForm" @click="otpErrorMsg= ''" >
                <div class="form-container" @click="otpErrorMsg=''">
                    <div class="vx-col w-full">
                        <div class="form_group">
                            <quillTextEditor :display="true" :wrapclass="''" :formscope="'verificationForm'" v-model="commentData" :fieldName="'commentData'"  :required="true"  :customValidNotRequire="false" :label="'Comments'" :placeHolder="'Comments'"  :canSpellCheck="true"/>
                        </div>
                    </div>
                    <div class="verification_info"> 
                        <h6>OTP Verification</h6>
                        <p>A One-Time 4 digits has been sent to {{ formattedEmail }}</p>
                    </div>
                    <div class="otp_filed">
                         
                            <otpInput v-model="otpVal" @input="updateOtpVal" :length="4" :wrapclass="'md:w-1/4'"  :showLabel="false" :fieldName="'otp'" :cid="'otp'" />
                            <!-- <immiInput  wrapclass="md:w-1/4" :onlyNumbers="true" :allowFloatingPoint="false" :maxLength="1" :formscope="'verificationForm'" v-model="otp.first" :fieldName="'first'" :cid="'first'" :required="false" :display="true"  />
                            <immiInput  wrapclass="md:w-1/4" :onlyNumbers="true" :allowFloatingPoint="false" :maxLength="1" :formscope="'verificationForm'" v-model="otp.second" :fieldName="'second'" :cid="'second'" :required="false" :display="true"  />
                            <immiInput  wrapclass="md:w-1/4" :onlyNumbers="true" :allowFloatingPoint="false" :maxLength="1" :formscope="'verificationForm'" v-model="otp.third" :fieldName="'third'" :cid="'third'" :required="false" :display="true"  />
                            <immiInput  wrapclass="md:w-1/4" :onlyNumbers="true" :allowFloatingPoint="false" :maxLength="1" :formscope="'verificationForm'" v-model="otp.fourth" :fieldName="'fourth'" :cid="'fourth'" :required="false" :display="true"/> -->
                         
                        <input type="hidden" :name="'primaryDocs'" v-validate="'required'"  data-vv-as="Field"  v-model="getOtpVal">
                        <span v-show="errors.has( 'verificationForm'+'.primaryDocs')" class="text-danger text-sm">*OTP is required</span>
                    </div>
                    <span v-if="isResendDisabled" class="otp_timer">Resend code in <b>{{ resendTimer }}s</b></span>
                    <!-- <span class="otp_timer">Resend code in <b>30</b> Sec</span> -->
                    <button   @click="resendOtp()" class="IB_primary-btn" type="filled" :disabled="isResendDisabled">Resend Code</button>
                    <div class="text-danger text-sm formerrors custom_margin" v-show="otpErrorMsg">
                        <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius" icon-pack="IntakePortal"
                        icon="IP-information-button" active="true">{{ otpErrorMsg }}</vs-alert>
                    </div>                    
                </div>
                <div class="popup-footer relative">
                    <span class="loader" v-if="loadingRequest" ><img src="@/assets/images/main/loader.gif" /></span>
                    <vs-button color="dark" @click="hideMe(false)" class="cancel" type="filled">Cancel</vs-button>
                    <vs-button color="success" @click="submitVerification()" class="save" type="filled">Submit</vs-button>
                </div>
            </form>
        </div>
        </modal>
    </div>
</template>
<script>
import otpInput from "@/views/forms/fields/otpInput.vue";
import immiInput from "@/views/forms/fields/simpleinput.vue";
import quillTextEditor from"@/views/forms/fields/quillTextEditor.vue";
export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components:{
        otpInput,
        immiInput,
        quillTextEditor
    },
    data: () => ({
        otpVal:'',
        cancelMeatingReason:'',
        loadingRequest:false,
        meetingErr:'',
        otp:{
            first:null,
            second:null,
            third:null,
            fourth:null,
        },
        resendTimer: 30, // 30 seconds timer
        isResendDisabled: true,
        resendInterval: null,
        otpVerificationData:'',
        commentData:'',
    }),
    props:{
        petitionDetails:null,
        callFromEdit:{
            type:Boolean,
            default:false
        },
        i9Id:'',
        approveType:null,
        otpErrorMsg:''
    },
    methods:{
        updateOtpVal(data){
            this.otpVerificationData = data
        },
        hideMe(callFormSubmit = false, data = '', hidepopup = true, commentDat=''){
            this.$emit('Hideverification', callFormSubmit, data, hidepopup, commentDat);
            if(callFormSubmit == false){
                this.$modal.hide('otpVerificationModal');
            }
        },
        submitVerification(){
            this.$validator.validateAll('verificationForm').then((result)=>{
                if(result){
                    this.hideMe(true, this.otpVerificationData, false, this.commentData);
                }
            })
        },
        hideOtp(){
            this.$modal.hide('otpVerificationModal');
            this.otp = {
                first:null,
                second:null,
                third:null,
                fourth:null,
            }
        },
        resendOtp(){
            this.$emit('resendOtp');
            this.startResendTimer();
        },
        formatEmail(email) {
            const [localPart, domain] = email.split('@');
            if (localPart.length <= 2) {
                return email; // Not enough characters to mask
            }
            const firstPart = localPart.slice(0, 3);
            const lastPart = localPart.slice(-3);
            const maskedPart = '*'.repeat(localPart.length - firstPart.length - lastPart.length);
            return `${firstPart}${maskedPart}${lastPart}@${domain}`;
        },
        startResendTimer() {
            this.isResendDisabled = true;
            this.resendTimer = 30;

            this.resendInterval = setInterval(() => {
                if (this.resendTimer > 0) {
                this.resendTimer -= 1;
                } else {
                this.isResendDisabled = false;
                clearInterval(this.resendInterval);
                }
            }, 1000);
        },


    },
    mounted(){
        this.$modal.show('otpVerificationModal');
        this.startResendTimer();
    },
    computed:{
        getOtpVal(){
            let returnVal = '';
            let data = this.otpVerificationData;
            let lengthOfData = data.toString().length;
            if(lengthOfData === 4){
                returnVal = 'returnVal';
            }
            return returnVal;
        },
        formattedEmail() {
            return this.formatEmail(this.checkProperty(this.petitionDetails, 'verifierInfo', 'email'));
        },
    },
    created() {
        this.startResendTimer();
    },
    beforeDestroy() {
        clearInterval(this.resendInterval);
    },
}
</script>